var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Panel',[_c('template',{slot:"panel"},[_c('Breadcrumb',{attrs:{"routes":_vm.routes}}),_c('ContactUs',{ref:"ContactUs"}),_c('Space')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }